import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
// import AdminModule from './modules/admin/AdminModule';

// Import condicional do SlimApp apenas em ambiente de desenvolvimento
const SlimApp = import.meta.env.DEV ? lazy(() => import('./slim/SlimApp')) : null;

export default function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/admin" element={<AdminModule />} /> */}
        <Route path="/*" element={<App />} />

        {/* Rota da versão slim apenas em ambiente de desenvolvimento */}
        {import.meta.env.DEV && SlimApp && (
          <Route
            path="/slim/*"
            element={
              <Suspense fallback={<div>Carregando versão slim...</div>}>
                <SlimApp />
              </Suspense>
            }
          />
        )}
      </Routes>
    </Router>
  );
}
